export const FETCH_FILTER_DATA = 'filter/FETCH_FILTER_DATA';
